import { css } from "@emotion/css";
import styled from "@emotion/styled";

export const lensesListStyles = css`
    > .sds-card.sds-container {
        height: 100%;
        margin-bottom: 60px;
    }
`;

export const searchContainerStyle = css`
    > .sds-card-header {
        padding: 16px 8px;
    }

    > .sds-card-body {
        overflow: hidden;
        display: flex;
        flex-direction: column;
    }
`;

export const VirtualizedContainer = styled.div`
    height: 100%;
`;
